import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Table, TableContainer, Checkbox, Tooltip, IconButton, Paper, Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ButtonWrapper from "../components/Button";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FileUploader from "../../TCPForms/reusableComponents/FileUploader";

const IdentifyNoc = ({ formData, tenantId, handleTabChange, handleSubTabChange, isEmployee }) => {
  const { data: { NOC: { NocDepartment: mdmsDepartments } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "NOC", [
    "NocDepartment",
  ]);
  const { documents } = useSelector((state) => state.formMT);
  const { t } = useTranslation();

  const khasraDetails = formData?.khasraDetails || [];
  const tehsil = khasraDetails.length > 0 ? khasraDetails[0].tehsil : "";
  const authority = formData?.selectedOffice;
  const district = khasraDetails.length > 0 ? khasraDetails[0].district : "";
  const villageList = khasraDetails.length > 0 ? khasraDetails[0].villageName : "";
  const { data, isLoading, isSuccess, error } = Digit.Hooks.noc.useNOCExcelSearch(tenantId, authority, tehsil, district, villageList);
  console.log("nocDepartmentdata", data, formData, mdmsDepartments);
  function fetchDepartmentMessages(data, departmentList) {
    console.log("logFromFucntion", data, departmentList);

    return data && departmentList
      ? departmentList
          ?.filter((dept) => data[dept.code] === "Yes")
          ?.map((dept) => ({
            code: dept.code,
            message: dept.message,
            name: dept.name,
          }))
      : [];
  }
  const departments = fetchDepartmentMessages(data?.[0]?.Departments, mdmsDepartments?.[0]?.department);
  console.log("finalDepartments", departments);

  const { control, setValue, handleSubmit } = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const onSubmit = (data) => {
    // Get selected department names (keys with value true)
    console.log("dataFromSUbmit", data);

    // const selectedNames = Object.entries(data.departments)
    //   .filter(([_, checked]) => checked)
    //   .map(([name]) => name);

    // // // Map selected names to their department info (message and name)
    // const selectedDepartments = departments
    //   .filter((dept) => selectedNames.includes(dept.name))
    //   .map((dept) => ({
    //     name: dept.name,
    //     message: dept.message,
    //     code: dept.code,
    //   }));
    // console.log("Selected Departments:", selectedDepartments);
    // data = {
    //   ...formData,
    //   nocDetails: { ...formData?.nocDetails, applicantNOCData: [...(formData?.nocDetails?.applicantNOCData | []), ...selectedDepartments] },
    // };
    console.log("finalPayloadOfNoc", data);

    handleTabChange(1, data);
    // handleSubTabChange(5, data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* <h3>Select Departments</h3> */}
      <TableContainer className="table-container">
        <Table stickyHeader className="application-table">
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={{ width: "10%" }}>Sr. No.</th>
              <th style={{ width: "60%" }}>Department Name</th>
              <th style={{ width: "60%" }}>Upload NOC</th>
              {/* <th style={{ width: "30%" }}>Select</th> */}
            </tr>
          </thead>
          <tbody>
            {departments.map((dept, index) => (
              <tr key={dept.name}>
                <td>{index + 1}</td>
                <td>
                  {dept.name}
                  <Tooltip title={dept.message} arrow>
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </td>
                <td>
                  <FileUploader control={control} name={`${dept?.name}`} hasLabel={false} validationMsg="Upload File" isNoc={true} />
                </td>
                {/* <td style={{ textAlign: "center" }}>
                  <Controller
                    name={`departments.${dept.code}`}
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        checked={!!field.value}
                        color="primary"
                        onChange={(e) => field.onChange(e.target.checked)}
                        sx={{ padding: "0" }}
                      />
                    )}
                  />
                </td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      {!isEmployee && (
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleSubTabChange(3)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Next" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      )}
    </form>
  );
};

export default IdentifyNoc;
